module.exports = __webpack_public_path__ + "static/media/aquafury-5.2dcbd2c2.jpg";